module.exports = require('./helpers/bundle-url').getBundleURL('ksUvU') + "local.3deec0a6.png" + "?" + Date.now();